import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardV2UpdateEndorsementMutation,
	StarterDashboardV2UpdateEndorsementMutationVariables,
} from './updateEndorsement.graphql';
import { StarterDashboardV2UpdateEndorsement } from './updateEndorsement.graphql';

export type UpdateEndorsementInput = {
	endorsementId: string;
	petitionId: string;
	name?: string;
	title?: string;
	url?: string;
	content?: string;
	photo?: {
		url: string;
		photoCrop?: {
			height: number;
			width: number;
			xOffset: number;
			yOffset: number;
		};
	};
};

export type UpdateEndorsementResponse = NonNullable<StarterDashboardV2UpdateEndorsementMutation['updateEndorsement']>;

export async function updateEndorsement(
	input: UpdateEndorsementInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<UpdateEndorsementResponse> {
	const { data, errors } = await fetch<
		StarterDashboardV2UpdateEndorsementMutation,
		StarterDashboardV2UpdateEndorsementMutationVariables
	>({
		query: StarterDashboardV2UpdateEndorsement,
		variables: { input },
		rejectOnError: false,
	});

	if (errors) throw new Error(JSON.stringify(errors));
	if (!data) throw new Error('Empty data in updateEndorsement graphQL response');

	return data.updateEndorsement;
}
